import emptyFunction from "./utils/emptyFunction.js";
import normalizeWheel from "./utils/normalizeWheel.js";
import requestAnimationFramePolyfill from "./requestAnimationFramePolyfill.js";

var swapWheelAxis = function swapWheelAxis(normalizedEvent) {
  return {
    spinX: normalizedEvent.spinY,
    spinY: normalizedEvent.spinX,
    pixelX: normalizedEvent.pixelY,
    pixelY: normalizedEvent.pixelX
  };
};
/**
 * Used to handle scrolling trackpad and mouse wheel events.
 */


var WheelHandler = /*#__PURE__*/function () {
  function WheelHandler(onWheel, handleScrollX, handleScrollY, stopPropagation) {
    this.animationFrameID = null;
    this.deltaX = 0;
    this.deltaY = 0;
    this.handleScrollX = null;
    this.handleScrollY = null;
    this.stopPropagation = null;
    this.onWheelCallback = null;
    this.didWheel = this.didWheel.bind(this);

    if (typeof handleScrollX !== 'function') {
      handleScrollX = handleScrollX ? emptyFunction.thatReturnsTrue : emptyFunction.thatReturnsFalse;
    }

    if (typeof handleScrollY !== 'function') {
      handleScrollY = handleScrollY ? emptyFunction.thatReturnsTrue : emptyFunction.thatReturnsFalse;
    }

    if (typeof stopPropagation !== 'function') {
      stopPropagation = stopPropagation ? emptyFunction.thatReturnsTrue : emptyFunction.thatReturnsFalse;
    }

    this.handleScrollX = handleScrollX;
    this.handleScrollY = handleScrollY;
    this.stopPropagation = stopPropagation;
    this.onWheelCallback = onWheel;
    this.onWheel = this.onWheel.bind(this);
  }
  /**
   * Binds the wheel handler.
   * @param event The wheel event.
   */


  var _proto = WheelHandler.prototype;

  _proto.onWheel = function onWheel(event) {
    var normalizedEvent = normalizeWheel(event); // on some platforms (e.g. Win10), browsers do not automatically swap deltas for horizontal scroll

    if (navigator.platform !== 'MacIntel' && event.shiftKey) {
      normalizedEvent = swapWheelAxis(normalizedEvent);
    }

    var deltaX = this.deltaX + normalizedEvent.pixelX;
    var deltaY = this.deltaY + normalizedEvent.pixelY;
    var handleScrollX = this.handleScrollX(deltaX, deltaY);
    var handleScrollY = this.handleScrollY(deltaY, deltaX);

    if (!handleScrollX && !handleScrollY) {
      return;
    }

    this.deltaX += handleScrollX ? normalizedEvent.pixelX : 0;
    this.deltaY += handleScrollY ? normalizedEvent.pixelY : 0;
    event.preventDefault();
    var changed;

    if (this.deltaX !== 0 || this.deltaY !== 0) {
      if (this.stopPropagation()) {
        event.stopPropagation();
      }

      changed = true;
    }

    if (changed === true && this.animationFrameID === null) {
      this.animationFrameID = requestAnimationFramePolyfill(this.didWheel);
    }
  }
  /**
   * Fires a callback if the wheel event has changed.
   */
  ;

  _proto.didWheel = function didWheel() {
    this.animationFrameID = null;
    this.onWheelCallback(this.deltaX, this.deltaY);
    this.deltaX = 0;
    this.deltaY = 0;
  };

  return WheelHandler;
}();

export default WheelHandler;